var chunkMapping = {
	"340": [
		97340
	]
};
var idToExternalAndNameMapping = {
	"97340": [
		"default",
		"./WorkflowEditorV3",
		82798
	]
};
var idToRemoteMap = {
	"97340": [
		{
			"externalType": "script",
			"name": "workflowEditorV3"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"97340": {
		"shareScope": "default",
		"name": "./WorkflowEditorV3",
		"externalModuleId": 82798,
		"remoteName": "workflowEditorV3"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}